import React from 'react';
import styled from 'styled-components';
import { body2 } from 'ui/theme/typography/styles';
import { colors } from 'ui/theme/colors';
import { pxToRem } from 'utils/convert';
import { BasicOption } from 'ui/selects/BasicOption';
import { SelectOptionsContainer } from 'ui/selects/Selects.styles';

type StyleProps = { $isOpen?: boolean };

export const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  width: ${pxToRem(128)};
  box-sizing: border-box;
`;

export const IconWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  color: ${colors.textSecondary};
  padding-bottom: ${({ theme }) => theme.spacing.single};
`;

export type TriggerWrapperProps = {
  $isOpen: boolean;
  isDisabled?: boolean;
} & React.HTMLProps<HTMLButtonElement>;

export const TriggerWrapper = styled.button<TriggerWrapperProps>`
  display: flex;
  flex: 1 1 auto;
  ${body2};
  color: ${({ $isOpen, isDisabled, theme }) => {
    if (isDisabled) return theme.colors.textColors.textDisabled;
    return $isOpen ? theme.colors.primaryColors.purple100 : theme.colors.textColors.textPrimary;
  }};
  outline: none;
  border: none;
  align-items: center;
  background: #fff;
  border-radius: 5px;
  padding: 10px ${pxToRem(12)};
  margin: ${({ theme }) => theme.spacing.single};
  gap: 10px;
  &:focus-within {
    color: ${({ isDisabled, theme }) =>
      isDisabled ? theme.colors.textColors.textDisabled : theme.colors.primaryColors.purple100};
  }
`;

export const ValueDisplay = styled(BasicOption)`
  flex: 1 1 auto;
  text-align: left;
  min-width: ${pxToRem(65)};

  :hover {
    background: inherit;
  }
`;

export const SuffixWrapper = styled.span<StyleProps>`
  color: ${({ $isOpen, theme }) =>
    $isOpen ? theme.colors.primaryColors.purple100 : colors.textSecondary};
  margin-left: 5px;
`;

export const Placeholder = styled.span`
  color: ${colors.textSecondary};
`;
